import React, { useState } from "react";
import { Alert, CircularProgress } from "@mui/material";
import { Card, DatePicker, Button, Table, message } from "antd";
import "antd/dist/antd.css";
import axios from "axios";
import moment from "moment";
import { baseURL } from "../backend_url";
// import "./RateUpdate.css"; // reuse your styling if you have a common CSS

const { RangePicker } = DatePicker;

export default function UpdateForm({ accessType }) {
  const [dates, setDates] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleFetch = async () => {
    if (dates.length < 2) {
      message.error("Please select a valid start and end date.");
      return;
    }

    const start = moment(dates[0]).format("YYYY-MM-DD HH:mm:ss");
    const end = moment(dates[1]).format("YYYY-MM-DD HH:mm:ss");

    setLoading(true);
    setErrorMsg("");
    try {
      const response = await axios.get(
        `${baseURL}/unified_fast?start=${start}&end=${end}`
      );
      setData(response.data);
    } catch (error) {
      console.error(error);
      setErrorMsg("Failed to fetch data from API");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Ticket ID",
      dataIndex: "ticket_id",
      key: "ticket_id",
      width: 120,
    },
    {
      title: "Subject",
      dataIndex: "ticket_subject",
      key: "ticket_subject",
      width: 250,
    },
    {
      title: "Caller",
      dataIndex: "call_from",
      key: "call_from",
      width: 120,
    },
    {
      title: "Start Time",
      dataIndex: "call_start",
      key: "call_start",
      width: 180,
    },
    {
      title: "End Time",
      dataIndex: "call_end",
      key: "call_end",
      width: 180,
    },
  ];

  return (
    <div className="rate-update-container">
      <Card
        title="Vonage & HubSpot Unified Dashboard"
        style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.15)", margin: "20px auto", width: "90%" }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
          <span style={{ fontWeight: 600, marginRight: 10 }}>Select Range:</span>
          <RangePicker
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            onChange={(val) => setDates(val)}
          />
          <Button
            type="primary"
            style={{ marginLeft: 12 }}
            onClick={handleFetch}
            disabled={loading}
          >
            Fetch Data
          </Button>
        </div>

        {errorMsg && (
          <Alert severity="error" style={{ marginBottom: 10 }}>
            {errorMsg}
          </Alert>
        )}

        {loading && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <CircularProgress />
          </div>
        )}

        {!loading && data && (
          <>
            <div style={{ marginBottom: 15 }}>
              <strong>HubSpot Tickets:</strong> {data.hubspot_ticket_count} &nbsp;&nbsp;
              <strong>Vonage Calls:</strong> {data.vonage_call_count} &nbsp;&nbsp;
              <strong>Matched Customers:</strong> {data.matched_customers}
            </div>

            <Table
              dataSource={data.matches || []}
              columns={columns}
              rowKey={(r) => `${r.ticket_id}-${r.call_start}`}
              pagination={{ pageSize: 10 }}
              bordered
            />
          </>
        )}
      </Card>
    </div>
  );
}
